import {
  SET_FREE_POST_APPLICATION_DATA,
  SET_FREE_POST_STATUS_HISTORY,
  CLEAR_FREE_POST_STATUS_HISTORY,
} from "../actions/freePost";

const initialState = {
  applicationData: null,
  statusHistoryData: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FREE_POST_APPLICATION_DATA:
      return {
        ...state,
        applicationData: action.applicationData,
      };
    case SET_FREE_POST_STATUS_HISTORY:
      return {
        ...state,
        statusHistoryData: action.statusHistoryData,
      };
    case CLEAR_FREE_POST_STATUS_HISTORY:
      return {
        ...state,
        statusHistoryData: null,
      };
    default:
      return state;
  }
};
